exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".section__head{text-align:center;margin-bottom:17px}.section__head h2{font-size:16px;color:#a27c2c;margin-bottom:6px;letter-spacing:2px;text-transform:uppercase}.section__head h2:last-child{margin-bottom:0}.section__head p{font-size:16px;font-weight:700;color:#9b9b9b}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SectionHead.vue
// module id = 396
// module chunks = 0